import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import * as yup from 'yup';
import { withFormik } from 'formik';
import _ from 'lodash';
import loadable from '@loadable/component';

import { submitContactForm } from 'common/actions/AppActions';

import { capfl, canUseDOM } from 'common/utils';

import { reactiveTemplateConfigSelector } from 'common/selectors/theme';
const ContactFormVariant = loadable(props => import(`./${props.blockVariant}`));

class ContactForm extends PureComponent {
  render () {
    const {
      t,
      inverted = false,
      blockSettings,
      ...rest
    } = this.props
    return (
      <ContactFormVariant
        blockVariant={_.get(blockSettings, 'blockVariant')}
        inverted={inverted}
        t={t}
        {...rest}
      />
    )
  }
}

const formInitialValues = {
  name: '',
  phone: '',
  email: '',
  message: ''
};

const getFormMessages = t => {
  return {
    email: {
      invalid: capfl(t('invalid email address')),
      required: capfl(`${t('email')} ${t('is required')}!`)
    },
    message: {
      required: capfl(`${t('message')} ${t('is required')}!`)
    }
  };
};

const formikEnhancer = withFormik({
  mapPropsToValues: () => {
    let propsToReturn = { ...formInitialValues };
    return propsToReturn;
  },
  validationSchema: ({ t }) => {
    const messages = getFormMessages(t);
    return yup.object().shape({
      name: yup.string().nullable(),
      phone: yup.string().nullable(),
      email: yup
        .string()
        .email(messages.email.invalid)
        .required(messages.email.required),
      message: yup
        .string()
        .required(messages.message.required)
    });
  },
  handleSubmit: (values, { props, setSubmitting, resetForm }) => {
    const { dispatchSubmitContactForm, t, subject = '' } = props;
    const emailSubject = subject ? subject : capfl(t('contact form message'));
    if (canUseDOM()) {
      _.set(values, 'uri', window.location.href)
    }
    dispatchSubmitContactForm({...values, ...{ subject: emailSubject }}, resetForm);
    setSubmitting(false);
  },
  enableReinitialize: true,
  displayName: 'ContactForm'
});

const EnhancedContactForm = formikEnhancer(ContactForm);

const makeMapStateToProps = () => {
  const reactiveTemplateConfig = reactiveTemplateConfigSelector('ContactFormVariant');
  return (state, props) => {
    return {
      blockSettings: {
        blockVariant: reactiveTemplateConfig(state, props)
      }
    };
  };
}

const mapDispatchToProps = dispatch => {
  return {
    dispatchSubmitContactForm: (values, successCallback) => {
      dispatch(submitContactForm(values, true, successCallback));
    }
  };
};

const ContactFormConnected = connect(
  makeMapStateToProps,
  mapDispatchToProps
)(EnhancedContactForm);

export default withTranslation()(ContactFormConnected);
